import { uploadFile, uploadFilePublic } from "api/upload/uploadFile";
import { uploadFileOnURL } from "api/upload/uploadImgOnR2";
import addNotification from "helpers/notify";
import { v4 as uuidv4 } from "uuid";
import JSZip from "jszip";

export const uploadFileToServer = async (file, isPublic = false) => {
  // No file, no upload: never hand back a key nothing was stored under
  // (companies carried "<uuid>.undefined.gz" logos that way).
  if (!file || !file.name) return null;
  try {
    const zip = new JSZip();
    const fileExt = file?.name?.split(".").pop();
    const name = uuidv4() + "." + fileExt + "." + "gz";

    let res;
    if (isPublic) {
      res = await uploadFilePublic({ fileNames: [name] });
    } else {
      res = await uploadFile({ fileNames: [name] });
    }

    const putUrl = res && Array.isArray(res.uploadUrls) ? res.uploadUrls[0] : null;
    if (!putUrl) return null;
    zip.file(file?.name, file);
    const zipBlob = await zip.generateAsync({ type: "blob" });
    await uploadFileOnURL({ url: putUrl, body: zipBlob });

    return name;
  } catch (error) {
    console.error("Error uploading file to server:", error);
    return null; // Return null in case of error
  }
};
